// extracted by mini-css-extract-plugin
export default {"inner":"Notification_inner__AsXeu","notification":"Notification_notification__rRJxm"};